import { CommonPerm } from "@enum/common/permission/common-perm.enum";

export const ConfigurationSection = [
    {
        section: 'Configurações',
        permission: ['*', CommonPerm.Roles_View],
    },
    {
        title: 'Cargos e permissões',
        icon: 'admin_panel_settings',
        permission: ['*', CommonPerm.Roles_View],
        root: true,
        page: '/admin/configuracao/cargos',
        bullet: 'dot',
    },
];